import React from "react";

const DEFAULT_BORDER_COLOR = "#3AC4FF";
const DEFAULT_BORDER_COLOR_SELECTED = "#31A5D6";
// Softer versions of correct colors (lighter than interaction.correct)
const HANDLE_TRUE_COLOR = "#A8D0A8"; // softer version of interaction.correct.DEFAULT (#8FBC8F)
const HANDLE_TRUE_COLOR_SELECTED = "#8FBC8F"; // interaction.correct.DEFAULT
// Softer versions of error colors (muted to match true handle brightness)
const HANDLE_FALSE_COLOR = "#D4908F"; // softer version of creator.error.DEFAULT
const HANDLE_FALSE_COLOR_SELECTED = "#C47A79"; // softer version of creator.error.hover

export const HANDLE_SIZE = "20px";

function getHandleBorderColor(
  selected: boolean,
  customColor: string | undefined,
  variant: "default" | "true" | "false"
): string {
  if (customColor) {
    return customColor;
  }
  if (variant === "true") {
    return selected ? HANDLE_TRUE_COLOR_SELECTED : HANDLE_TRUE_COLOR;
  }
  if (variant === "false") {
    return selected ? HANDLE_FALSE_COLOR_SELECTED : HANDLE_FALSE_COLOR;
  }
  return selected ? DEFAULT_BORDER_COLOR_SELECTED : DEFAULT_BORDER_COLOR;
}

export function getHandleStyle(
  connected: boolean,
  selected: boolean,
  customColor: string | undefined,
  variant: "default" | "true" | "false",
  extra?: React.CSSProperties,
  colorOverride?: string
): React.CSSProperties {
  const borderColor =
    colorOverride ?? getHandleBorderColor(selected, customColor, variant);
  return {
    width: HANDLE_SIZE,
    height: HANDLE_SIZE,
    backgroundColor: connected ? borderColor : "var(--pi-surface)",
    border: `2px solid ${borderColor}`,
    boxShadow: connected ? "inset 0 0 0 3px var(--pi-surface)" : undefined,
    borderRadius: "100%",
    zIndex: 1,
    cursor: "pointer",
    ...extra,
  };
}

export function isHandleConnected(
  nodeId: string,
  handleId: string | null | undefined,
  handleType: "source" | "target",
  edges: Array<{
    source: string;
    target: string;
    sourceHandle?: string | null;
    targetHandle?: string | null;
  }>
): boolean {
  if (handleType === "source") {
    return edges.some(
      (edge) =>
        edge.source === nodeId &&
        (handleId === undefined
          ? edge.sourceHandle === null || edge.sourceHandle === undefined
          : edge.sourceHandle === handleId)
    );
  }
  return edges.some(
    (edge) =>
      edge.target === nodeId &&
      (handleId === undefined
        ? edge.targetHandle === null || edge.targetHandle === undefined
        : edge.targetHandle === handleId)
  );
}
